export default [
  {
    name: 'setting-financial-control',
    path: '/settings/financial-control',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Controle Financeiro',
      icon: 'dvr',
      label: 'Controle Financeiro',
      roles: ['Admin']
    }
  }
]
